import axios from "axios";
import Links from "../constants/Links";

/**
 * Admin operations API hook — operational stats and the system-wide
 * session kill switch.
 */
const Admin = {
    /**
     * @description Operational dashboard stats (sessions, entities, runtime).
     * Auth: ADMIN or SUPER_ADMIN.
     * @returns {Promise<AxiosResponse<*>>}
     */
    systemStats: async () => {
        return axios.get(Links.admin.systemStats)
    },

    /**
     * @description System-wide kill switch: revokes every active session
     * except those owned by SUPER_ADMIN users. Auth: SUPER_ADMIN only.
     * @returns {Promise<AxiosResponse<*>>} body: { revoked: number }
     */
    revokeAllSessions: async () => {
        return axios.post(Links.admin.revokeAllSessions)
    },
}

export default Admin
